/** 5 minutes in seconds */
export const DEFAULT_STORAGE_DURATION = 300

/** 1 hour in seconds */
export const ONE_HOUR_STORAGE_DURATION = 3600
